/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");
const Enumerable = require("linq");

angular
    .module("ROGER")
    .controller("DashboardController", [
        "$scope", "$http", "$sessionStorage", "retailTargetsService", "$window", "$translate", "$oidc",
        function ($scope, $http, $sessionStorage, retailTargetsService, $window, translate, oidc) {

            // Storage
            $scope.$storage = $sessionStorage;

            // Period of retail targets graph
            $scope.selectedPeriodRetailTargets;

            $scope.selectedPreviousRetTargetsPeriod = false;
            $scope.otherRetTargetsPeriod = 0;
            $scope.retailTagretsDataView = "graph";
            $scope.retailTagretsTableData = [];

            // Retailer
            $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                    $scope.refresh();
                }
            });

            var w = angular.element($window);
            w.bind("resize", function () {
                var widthOfRetTargBox = retailTargetsService.getWidthOfRetailtargetsBox();
                if (widthOfRetTargBox !== 0 && widthOfRetTargBox !== retailTargetsService.widthOfRetailTargetsBox) {
                    $scope.changeRetailTargetPeriod($scope.selectedPeriodRetailTargets);
                }
            });

            // Retails targets
            $scope.retailTargetsPeriod = {};
            $scope.refreshingRetailTargetsMessages = false;
            $scope.refreshRetailTargets = function (refreshData) {
                if (angular.isUndefinedNullOrEmpty(refreshData)) {
                    refreshData = false;
                }

                var retailTargetsParams = retailTargetsService.getRetailTargetsPeriod();
                $scope.refreshingRetailTargetsMessages = true;
                $scope.selectedPreviousRetTargetsPeriod = false;

                var previousPeriod = getPreviousPeriod();
                $scope.otherRetTargetsPeriod = "Q" + previousPeriod["quarter"] + "/" + previousPeriod["year"];

                var data = retailTargetsService.getData();
                if (refreshData || data === undefined) {
                    $http
                        .get("/api/dashboard/retail-targets/" + $scope.$storage.retailer.Id, {
                            params: {},
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            },
                            cache: false
                        })
                        .then(function (response) {
                            retailTargetsService.setData(response.data);
                            calculateData(retailTargetsParams);
                        })
                        .then(function () {
                            $scope.refreshingRetailTargetsMessages = false;
                        });
                } else {
                    calculateData(retailTargetsParams);
                }
            };

            $scope.changeTargetsDataView = function (view) {
                $scope.retailTagretsDataView = view;
            };

            function calculateData(dataPeriod, selectedPeriod) {
                $scope.refreshingRetailTargetsMessages = false;
                translate("Plan")
                    .then(function (translation) {
                        // Calculate graph data
                        retailTargetsService.processDataGraph(dataPeriod, {
                            Plan: translation
                        });
                        $scope.retailTargetsPeriod = retailTargetsService.getGraphPeriods();

                        if ($scope.retailTargetsPeriod.hasOwnProperty(dataPeriod["actualPeriod"])) {
                            if (angular.isUndefinedNullOrEmpty(selectedPeriod)) {
                                $scope.changeRetailTargetPeriod(dataPeriod["actualPeriod"]);
                            } else {
                                $scope.changeRetailTargetPeriod(selectedPeriod);
                            }
                        }

                        // Calculate table data
                        $scope.retailTagretsDataHeaders = retailTargetsService.getTableHeaders();
                        $scope.retailTagretsTableData = retailTargetsService.processDataTable(dataPeriod);
                    });
            }

            $scope.changeRetailTargetPeriod = function (period) {
                if (!angular.isUndefinedNullOrEmpty(period)) {
                    $scope.selectedPeriodRetailTargets = period;
                    retailTargetsService.createGraph(period);
                }
            };

            $scope.isPercentColumn = function (tableHeader) {
                if (tableHeader.includes("Ach") || tableHeader.includes("CCHybridMix")) {
                    return true;
                }
                return false;
            };

            $scope.isPercentColumnMarked = function (tableHeader) {
                if (tableHeader.includes("Ach")) {
                    return true;
                }
                return false;
            };

            $scope.changeToPercent = function (value) {
                return (value * 100).toFixed(1);
            };

            function getPreviousPeriod() {
                var d = new Date();
                d.setMonth(d.getMonth() - 3);
                return retailTargetsService.getRetailTargetsPeriod(d);
            }

            $scope.changeRetailTargetQuarterPrevious = function () {
                $scope.refreshingRetailTargetsMessages = true;
                $scope.selectedPreviousRetTargetsPeriod = true;

                var nextPeriod = retailTargetsService.getRetailTargetsPeriod();
                $scope.otherRetTargetsPeriod = "Q" + nextPeriod["quarter"] + "/" + nextPeriod["year"];

                var retailTargetsParams = getPreviousPeriod();
                calculateData(retailTargetsParams, "Q" + retailTargetsParams["quarter"] + retailTargetsParams["year"]);
            };

            // System messages
            $scope.refreshingSystemMessages = false;
            $scope.refreshSystemMessages = function () {

                $scope.refreshingSystemMessages = true;
                return $http
                    .get("/api/dashboard/system-message/" + $scope.$storage.retailer.Id + "/" + $scope.$storage.retailer.CountryId, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.systemMessages = response.data;
                    })
                    .then(function () {
                        $scope.refreshingSystemMessages = false;
                    });
            };

            // Retails
            $scope.refreshingRetails = false;
            $scope.refreshRetails = function () {
                $scope.refreshingRetails = true;
                return $http.get("/api/dashboard/retails/" + $scope.$storage.retailer.Id, {
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    }
                })
                    .then(function (response) {
                        $scope.retails = response.data;
                        $scope.retailsModels =
                            Enumerable
                                .from(response.data)
                                .distinct(function (x) { return x.ModelName; })
                                .select(function (x) { return { Id: x.ModelId, Name: x.ModelName }; })
                                .toArray();
                        $scope.retailsRetailers =
                            Enumerable
                                .from(response.data)
                                .distinct(function (x) { return x.RetailerName; })
                                .select(function (x) { return { Id: x.RetailerId, Name: x.RetailerName }; })
                                .toArray();
                    })
                    .then(function () {
                        $scope.refreshingRetails = false;
                    });
            };

            $scope.getQuantity = function (retailerId, modelId) {
                return Enumerable
                    .from($scope.retails)
                    .where(function (x) { return x.RetailerId === retailerId && x.ModelId === modelId; })
                    .select(function (x) { return x.Quantity; })
                    .singleOrDefault();
            };

            $scope.getRetailerTotal = function (retailerId) {
                return Enumerable
                    .from($scope.retails)
                    .where(function (x) { return x.RetailerId === retailerId; })
                    .sum(function (x) { return x.Quantity; });
            };

            $scope.getModelTotal = function (modelId) {
                return Enumerable
                    .from($scope.retails)
                    .where(function (x) { return x.ModelId === modelId; })
                    .sum(function (x) { return x.Quantity; });
            };

            $scope.getTotal = function () {
                return Enumerable
                    .from($scope.retails)
                    .sum(function (x) { return x.Quantity; });
            };

            // Nearest cars
            $scope.refreshingNearestCars = false;
            $scope.refreshNearestCars = function () {
                $scope.refreshingNearestCars = true;
                return $http
                    .get("/api/dashboard/nearest-cars/" + $scope.$storage.retailer.Id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.nearestCars = response.data;
                    }).then(function () {
                        $scope.refreshingNearestCars = false;
                    });
            };

            // Expiring reservations
            $scope.refreshingExpiringReservations = false;
            $scope.refreshExpiringReservations = function () {
                $scope.refreshingExpiringReservations = true;
                return $http
                    .get("/api/dashboard/expiring-reservations/" + $scope.$storage.retailer.Id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.expiringReservations = response.data;
                    }).then(function () {
                        $scope.refreshingExpiringReservations = false;
                    });
            };

            // Closest expiring sales order requests
            $scope.refreshingExpiringRequests = false;
            $scope.refreshExpiringRequests = function () {
                $scope.refreshingExpiringRequests = true;
                return $http
                    .get("/api/dashboard/expiring-requests/" + $scope.$storage.retailer.Id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.expiringRequests = response.data;
                        console.log($scope.expiringRequests);
                    }).then(function () {
                        $scope.refreshingExpiringRequests = false;
                    });
            };

            // Dashboard
            $scope.refresh = function () {
                clearTimeout($scope.refreshTimer);

                $scope.refreshSystemMessages();
                $scope.refreshRetails();
                $scope.refreshNearestCars();
                $scope.refreshExpiringReservations();
                $scope.refreshExpiringRequests();
                $scope.refreshRetailTargets(true);

                $scope.refreshTimer = setTimeout($scope.refresh, $scope.$storage.dashboard.refreshTime);
            };

            $scope.$watch("language", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $scope.refresh();
                }
            });

            $scope.$watch("$storage.dashboard.refreshTime", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $scope.refresh();
                }
            });

            // On Load
            if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                $scope.refresh();
            }

            $scope.$on("$locationChangeStart", function (event) {
                clearTimeout($scope.refreshTimer);
            });
        }
    ]);
